import type { MaybeRefOrGetter } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IWellKnownDomainsList, IWellKnownDomainsResponse } from '../types';
import {
  WELL_KNOWN_DOMAINS_LIST_API_URL,
  WELL_KNOWN_DOMAINS_LIST_QUERY_KEY,
  WELL_KNOWN_LINKS_PERMISSIONS,
} from '../constants';

export default function useDomainsListQuery(enabled: MaybeRefOrGetter<boolean>): IContextQueryResult<
  IWellKnownDomainsResponse,
  Error,
  IWellKnownDomainsList
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IWellKnownDomainsResponse, Error, IWellKnownDomainsList>({
    queryKey: [WELL_KNOWN_DOMAINS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IWellKnownDomainsResponse>(
      WELL_KNOWN_DOMAINS_LIST_API_URL,
      {
        signal,
        permission: WELL_KNOWN_LINKS_PERMISSIONS.EDIT,
      },
    ),
    select: (data) => data.domains,
    enabled,
  });
}
